var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{staticClass:"mobile-menu-toggler"},[_c('tasty-burger-button',{attrs:{"type":'collapse',"active":_vm.menu,"color":'#fff',"size":'m',"active-color":'#fff'},on:{"toggle":_vm.toggleMenu}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }